export default "__VITE_ASSET__Ckl0EOyp__";